import { FormSubmissionStatus } from '@/__generated__/types';

export const POS_FORM_FIELD_LABELS = {
    restaurantName: 'restaurantName',
    contactName: 'contactName',
    mobileNumber: 'mobileNumber',
    email: 'email',
    city: 'city',
    businessType: 'businessType',
    message: 'message',
    referralSource: 'referralSource'
} as const;

export const renderOptionalFormValue = (value: string | null | undefined): string => {
    if (value == null) return '-';

    return value.trim() ? value : '-';
};

const getRawFormFieldValue = (fields: readonly { label: string; value: string }[], label: string): string | undefined => {
    return fields.find((item) => item.label === label)?.value;
};

export const getFormFieldValue = (fields: readonly { label: string; value: string }[], label: string): string => {
    const directValue = getRawFormFieldValue(fields, label);

    if (directValue !== undefined) return renderOptionalFormValue(directValue);
    return '-';
};

export const getFormSubmissionStatusOptions = (): FormSubmissionStatus[] => [
    FormSubmissionStatus.New,
    FormSubmissionStatus.Contacted,
    FormSubmissionStatus.Qualified,
    FormSubmissionStatus.Converted,
    FormSubmissionStatus.Closed
];

export const formatFormSubmissionStatus = (status: FormSubmissionStatus): string => {
    return status
        .toLowerCase()
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

export const formatFormSubmissionDate = (timestamp: number | null | undefined): string => {
    if (timestamp == null) return '-';

    const normalizedTimestamp = timestamp < 100000000000 ? timestamp * 1000 : timestamp;
    const date = new Date(normalizedTimestamp);

    if (Number.isNaN(date.getTime())) return '-';

    return date.toLocaleString();
};
